/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RelationshipTypeModel } from '../../models/relationship-type-model';

export interface RelationshipTypePost$Params {
      body?: RelationshipTypeModel
}

export function relationshipTypePost(http: HttpClient, rootUrl: string, params?: RelationshipTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, relationshipTypePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<string>;
    })
  );
}

relationshipTypePost.PATH = '/RelationshipType';
